<template>
  <div class="position">
    <div class="position__button" :class="{'position__button--within': positionWithinBounds}" @click="getCurrentPosition">
      <div class="position__icon" :class="{'position__icon--within': positionWithinBounds}"></div>
      <span class="position__text">{{ $t('myPosition') }}</span>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '@/bus'

  export default {
    name: 'Position',
    data: () => ({
      options: {
        maximumAge: 30000,
        timeout: 10000,
        enableHighAccuracy: true
      }
    }),
    computed: {
      positionWithinBounds () {
        return this.$store.state.positionWithinBounds
      },
      currentPosition () {
        return this.$store.state.currentPosition
      }
    },
    methods: {
      _success (position) {
        const { latitude, longitude } = position.coords
        this.$store.commit('currentPosition', { latitude, longitude })
        this.$store.commit('loading', false)
      },
      _error () {
        this.$store.commit('currentPosition', false)
        this.$store.commit('loading', false)
        EventBus.$emit('recenterViewport')
      },
      getCurrentPosition () {
        if (this.currentPosition !== null && typeof this.currentPosition === 'object') {
          return EventBus.$emit('recenterPosition')
        }

        if (navigator.geolocation) {
          this.$store.commit('currentPosition', null)
          this.$store.commit('loading', true)
          navigator.geolocation.watchPosition(this._success, this._error, this.options)
        }
      }
    },
    watch: {
      currentPosition (newVal, oldVal) {
        if (newVal !== null && typeof newVal === 'object' && !oldVal) {
          EventBus.$emit('recenterPosition')
        }
      }
    },
    mounted () {
      EventBus.$on('getCurrentPosition', this.getCurrentPosition)
    }
  }
</script>

<style scoped>
  .position {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .position__icon {
    background-image: url('/static/images/target.png');
    background-size: 14px;
    height: 14px;
    width: 14px;
    position: relative;
  }
  .position__icon--within {
    background-image: url('/static/images/accepted.png');
    background-size: 11px 9px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .position__text {
    text-transform: uppercase;
    margin-top: 2px;
    padding-left: 1rem;
  }
  .position__button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.8rem 0 1.2rem;
    margin: 0 10px;
    border: 1px solid black;
    font-size: 10px;
    letter-spacing: 2px;
    line-height: 10px;
    background: #FFF;
    cursor: pointer;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .3);
    height: 40px;
    box-sizing: border-box;
  }
  .position__button--within {
    background: none;
    box-shadow: none;
    border-color: #DDD;
  }
  @media only screen and (max-device-width: 768px) {
    .position__button {
      width: auto;
      height: auto;
      padding: .5rem;
      border-radius: 50%;
    }
    .position__text {
      display: none;
    }
    .position__icon--within {
      background-image: url('/static/images/target.png');
      background-size: 14px;
      height: 14px;
      width: 14px;
    }
    .position__icon--within:after {
      content: '';
      background: white;
      background-image: url('/static/images/accepted.png');
      background-size: 6px 5px;
      background-position: center;
      background-repeat: no-repeat;
      width: 10px;
      height: 10px;
      position: absolute;
      top: -10px;
      right: -10px;
      border-radius: 50%;
      border: 1px solid #63A78A;
    }
  }
</style>



// WEBPACK FOOTER //
// PositionButton.vue?1d8c491d